import { VISIBLE_ISSUE } from '../../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case VISIBLE_ISSUE.LOAD:
      return {
        ...state,
        loading: true,
      };
    case VISIBLE_ISSUE.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case VISIBLE_ISSUE.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
